import { FC } from 'react'
import { theme } from '../../../theme/theme'
import { LoadingCheck } from '../../LoadingCheck'
import { ButtonProps, Button } from '../Button'
import { useEmitEvent } from '../../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'

interface LinkButtonProps extends ButtonProps {
  href: string
}

export const LinkButton: FC<LinkButtonProps> = ({
  href,
  buttonStyle,
  secondary,
  buttonColor = theme.color.plum,
  loading,
  text,
  disabled,
}) => {
  const emitEvent = useEmitEvent()

  const handleClick = () => {
    emitEvent({
      eventType: TrackingEvents.CLICK,

      action: `link_button_to_${href}`,
      options: {
        metadata: {
          button_text: text,
        },
      },
    })
  }

  return (
    <Button
      to={href}
      style={buttonStyle}
      $disabled={disabled}
      $secondary={secondary}
      $buttonColor={buttonColor}
      onClick={handleClick}
    >
      {LoadingCheck(text, loading)}
    </Button>
  )
}
